<script setup lang="ts">
/**
 * Share Certificate (B32013 · PRS014) — 원본: Share Certificate.docx (TMP 864) 를 그대로 재현.
 *   [[company_name]] / [[uen]] / [[registered_office_address]] / [[cert_no]] / [[no_of_shares]] /
 *   [[member_name]] / [[shares_numeral]] / [[shares_words]] / [[share_class]] / [[issue_date]] → CddVarField
 *   [[Signers]] → AgmSigners(sc_Signers) — 이사 + 비서(기존 생성 규칙)
 */
import CddVarField from '../../../preset/components/final-dividends/cdd/CddVarField.vue';
import AgmSigners from '../../../preset/components/final-dividends/cdd/AgmSigners.vue';
import '../../../preset/components/final-dividends/docs/agmDoc.css';

defineProps<{ loading?: boolean; loadError?: string }>();
</script>

<template>
  <div class="agm-doc sc-doc">
    <div v-if="loading" class="sc-note">Loading the member's certificate data…</div>
    <div v-else-if="loadError" class="sc-note err">{{ loadError }}</div>

    <table class="sc-head">
      <tbody>
        <tr>
          <td class="sc-box">
            <div class="sc-box-l">Certificate No.</div>
            <div class="sc-box-v">*<CddVarField field-key="cert_no" label="Certificate No." />*</div>
          </td>
          <td class="sc-co">
            <div class="sc-co-name"><CddVarField field-key="company_name" label="Company Name" /></div>
            <div>(the “Company”)(Company Registration No. <CddVarField field-key="uen" label="UEN" />)</div>
          </td>
          <td class="sc-box">
            <div class="sc-box-l">No. of Shares</div>
            <div class="sc-box-v">*<CddVarField field-key="no_of_shares" label="No. of Shares" />*</div>
          </td>
        </tr>
      </tbody>
    </table>

    <p class="doc-p center">Incorporated in the Republic of Singapore under the Companies Act 1967</p>
    <p class="doc-p center">REGISTERED OFFICE: <CddVarField field-key="registered_office_address" label="Registered Office" /></p>

    <p class="doc-p sc-body">
      This is to certify that <CddVarField field-key="member_name" label="Member (shareholder)" /> is the Registered Holder of
      <CddVarField field-key="shares_numeral" label="Shares (numeral)" /> (<CddVarField field-key="shares_words" label="Shares (in words)" />)
      <CddVarField field-key="share_class" label="Class of shares" /> Shares fully paid in <CddVarField field-key="company_name" label="Company Name" />
      subject to the Constitution of the Company.
    </p>
    <p class="doc-p">Issued by the Company on <CddVarField field-key="issue_date" label="Issue date" />.</p>

    <AgmSigners var-key="sc_Signers" board-label="" />

    <p class="doc-p sc-noteline">
      NOTE: No transfer of any portion of the shares comprised in this Certificate will be registered unless accompanied by this Certificate
    </p>
  </div>
</template>

<style scoped>
.sc-doc { font-size: 12px; }
.sc-note { font-size: 11.5px; color: #42506a; background: #eef4ff; border: 1px solid #cfe0ff; border-radius: 8px; padding: 6px 10px; margin-bottom: 10px; }
.sc-note.err { color: #b42318; background: #fde8e7; border-color: #f5c2bd; }
.sc-head { width: 100%; border-collapse: collapse; margin-bottom: 10px; }
.sc-head td { vertical-align: top; padding: 6px; }
.sc-box { width: 22%; border: 1px solid #333; text-align: center; }
.sc-box-l { font-weight: 700; font-size: 11px; }
.sc-box-v { margin-top: 4px; font-weight: 700; }
.sc-co { text-align: center; }
.sc-co-name { font-weight: 800; font-size: 14px; }
.sc-body { margin-top: 14px; line-height: 1.8; }
.sc-noteline { margin-top: 18px; font-size: 10.5px; }
</style>
